<template>
  <div class="col-md-7">
    <div class="box-menu border-over-column">
      <div class="wrap">
        <div class="widget-tabs">
          <!-- TAB BUTTONS -->
          <ul class="widget-menu-tab">
            <li
              v-for="(item, index) in menuItems"
              :key="index"
              class="item-title"
              :class="{ active: activeTab === index }"
              @click="activeTab = index"
            >
              <span class="inner">{{ item.category.name }}</span>
            </li>
          </ul>
          <!-- TAB CONTENT -->
          <div class="widget-content-tab">
            <div v-if="menuItems.length">
              <div class="widget-content-inner active">
                <div
                  v-for="product in filteredProducts(activeTab) || []"
                  :key="product.id"
                  class="wg-menu-item"
                >
                  <div class="flex items-center">
                    <div class="name">
                      <router-link to="/menu">{{ product.name || "" }}</router-link>
                      <!-- <a href="#">{{ product.name || "" }}</a> -->
                    </div>
                    <div class="line"></div>
                    <div class="price">€{{ Number(product.price || 0).toFixed(2) }}</div>
                  </div>
                  <p class="description">
                    {{ truncate(product?.description, 30) }}

                    <span class="full-description-wrapper">
                      <span class="full-description">
                        {{ product?.description }}
                      </span>
                    </span>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { langStore } from "../../langStore";

export default {
  name: "MenuItemsComponent",
  data() {
    return {
      menuItems: [],
      activeTab: 0,
      langStore,
    };
  },

  watch: {
    "langStore.lang"() {
      this.fetchMenuItems();
    },
  },

  mounted() {
    this.fetchMenuItems();
  },

  methods: {
     async fetchMenuItems() {
      try {
        const response = await axios.get(
          `${process.env.VUE_APP_BASE_URL}/api/home-menu-items`,
          { params: { lang: this.langStore.lang } }
        );

        this.menuItems = response.data;
      } catch (error) {
        console.error("There was an error fetching the data:", error);
        this.$emitContentReady(); // still hide preload
      }
    },
    
    filteredProducts(categoryIndex) {
      const category = this.menuItems[categoryIndex];
      return category && Array.isArray(category.products)
        ? category.products
        : [];
    },

    truncate(text, length) {
      if (!text || typeof text !== "string") return ""; // prevents errors
      return text.length > length ? text.slice(0, length) + "..." : text;
    },
  },
};
</script>

<style scoped>
.widget-content-tab {
  position: relative; /* make this the reference for absolute children */
}

.wg-menu-item {
  position: relative; /* relative to position the full-description inside */
}
.description {
  position: relative;
  cursor: pointer;
}

/* Wrapper holds the tooltip */
.full-description-wrapper {
  position: absolute;
  top: 100%; /* show below the truncated text */
  left: 0;
  width: 100%;
  visibility: hidden;
  opacity: 0;
  transition: opacity 0.3s ease;
  z-index: 10;
}

/* Inner box with your desired styling */
.full-description {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  align-content: center;
  padding: 15px 30px;
  background: #2e7288;
  width: 100%;
  box-sizing: border-box;
  text-align: center;
}

/* Show wrapper on hover */
.description:hover .full-description-wrapper {
  visibility: visible;
  opacity: 1;
}
</style>
